/**
 * Zähler am App-Symbol auf dem Startbildschirm.
 *
 * Der stillste der drei Wege: keine Meldung, kein Ton — nur eine Zahl am Symbol, die
 * beim nächsten Blick aufs Gerät auffällt. Wird nicht überall unterstützt; wo nicht,
 * passiert nichts, und der Hinweisdialog in der App trägt die Information allein.
 */

interface BadgeFähig {
  setAppBadge?: (contents?: number) => Promise<void>
  clearAppBadge?: () => Promise<void>
}

export function setzeBadge(anzahl: number): void {
  const nav = navigator as Navigator & BadgeFähig
  try {
    if (anzahl > 0) void nav.setAppBadge?.(anzahl)
    else void nav.clearAppBadge?.()
  } catch {
    // Kein Grund, irgendetwas abzubrechen — der Zähler ist Beiwerk.
  }
}
